import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { Menu, Search } from "lucide-react";
import { type ReactNode, useState } from "react";
import { GlobalSearch } from "./global-search";
import { Sidebar } from "./sidebar";

interface TopBarProps {
  /** Slot vpravo — typicky NotificationBell + ThemeToggle, poskytuje AppShell. */
  actions?: ReactNode;
}

/** Horní lišta — hamburger na mobilu + search placeholder + pravý slot akcí. */
export function TopBar({ actions }: TopBarProps) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);

  return (
    <header
      className="sticky top-0 z-30 flex h-16 items-center gap-3 border-b border-border bg-card px-4 md:px-6"
      data-testid="app-top-bar"
    >
      {/* Mobilní hamburger */}
      <Sheet open={mobileOpen} onOpenChange={setMobileOpen}>
        <SheetTrigger asChild>
          <Button
            variant="ghost"
            size="icon"
            className="md:hidden"
            aria-label="Otevřít navigaci"
            data-testid="app-top-bar-menu"
          >
            <Menu className="h-5 w-5" />
          </Button>
        </SheetTrigger>
        <SheetContent
          side="left"
          className="w-[260px] border-r-0 bg-[hsl(var(--sidebar-bg))] p-0 text-[hsl(var(--sidebar-fg))]"
        >
          <SheetHeader className="sr-only">
            <SheetTitle>Navigace</SheetTitle>
          </SheetHeader>
          <Sidebar onNavigate={() => setMobileOpen(false)} />
        </SheetContent>
      </Sheet>

      {/* Globální vyhledávač — klienti, firmy, termíny, faktury. */}
      <div className="hidden flex-1 md:block md:max-w-md">
        <GlobalSearch />
      </div>

      <div className="flex-1 md:hidden" />

      {/* Mobilní vyhledávání — lupa otevře fullscreen overlay se stejným
          vyhledávačem. Esc i křížek overlay zavřou (Radix Sheet). */}
      <Sheet open={searchOpen} onOpenChange={setSearchOpen}>
        <SheetTrigger asChild>
          <Button
            variant="ghost"
            size="icon"
            className="md:hidden"
            aria-label="Otevřít vyhledávání"
            data-testid="app-top-bar-search-open"
          >
            <Search className="h-5 w-5" />
          </Button>
        </SheetTrigger>
        <SheetContent side="top" className="p-4" data-testid="app-top-bar-search-sheet">
          <SheetHeader className="sr-only">
            <SheetTitle>Vyhledávání</SheetTitle>
          </SheetHeader>
          {/* pr-10 nechává místo křížku SheetContent v pravém horním rohu. */}
          <div className="pr-10">
            <GlobalSearch autoFocus onNavigate={() => setSearchOpen(false)} />
          </div>
        </SheetContent>
      </Sheet>

      {actions ? <div className="flex items-center gap-1">{actions}</div> : null}
    </header>
  );
}
